import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-typing-indicator',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './typing-indicator.html',
})
export class TypingIndicator {}
